import errorIcon from "../../../assets/images/icons/errorOutline.svg"
import { Modal } from "../../../components/Modal"
import { useTranslation } from "react-i18next"

export function MeasurementReportDownloadErrorModal({
  isOpen,
  onClose,
  message,
}: {
  isOpen: boolean
  onClose: () => void
  message: string
}) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[500px] h-[200px] flex flex-col items-center justify-center'>
      <div className='flex items-center space-x-[8px] px-[24px]'>
        <img src={errorIcon} alt='error' className='w-[26px] h-[26px]' />
        <p className='text-center text-[14px] text-[#3E3E3E] whitespace-pre-wrap break-words'>{message}</p>
      </div>
      <button
        className='mt-[25px] w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-bold'
        onClick={onClose}
      >
        {t("common.close")}
      </button>
    </Modal>
  )
}
